import * as yup from 'yup';

// Регулярное выражение для проверки на наличие только русских и латинских букв
const nameRegex = /^[А-Яа-яA-Za-z]+$/;
// Получаем текущую дату
const currentDate = new Date();
// Получаем дату 100 лет назад
const oneHundredYearsAgo = new Date();
oneHundredYearsAgo.setFullYear(currentDate.getFullYear() - 100);

// Функция валидации даты
const validateDate = (value: string | undefined) => {
  if (!value) return true;

  // Проверяем формат DD.MM.YYYY
  const dateFormatRegex = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.(19\d{2}|20\d{2})$/;
  if (!dateFormatRegex.test(value)) return false;

  // Разбиваем дату на компоненты
  const [day, month, year] = value.split('.').map(Number);
  // Создаем объект даты (JavaScript считает месяцы с 0, поэтому вычитаем 1)
  const date = new Date(year, month - 1, day);

  // Проверяем, что дата не в будущем
  if (date > currentDate) return false;

  // Проверяем, что дата не старше 100 лет
  if (date < oneHundredYearsAgo) return false;

  return true;
};

export const applicationLinkValidator = yup.object().shape({
  name: yup
    .string()
    .required('Имя обязательно')
    .matches(nameRegex, 'Имя должно содержать только буквы, без пробелов, цифр и специальных символов'),
  surname: yup
    .string()
    .required('Фамилия обязательна')
    .matches(nameRegex, 'Фамилия должна содержать только буквы, без пробелов, цифр и специальных символов'),
  patronymic: yup
    .string()
    .optional()
    .matches(nameRegex, 'Отчество должно содержать только буквы, без пробелов, цифр и специальных символов')
    .nullable(),
  birthday: yup
    .string()
    .matches(/^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.(19\d{2}|20\d{2})$/, 'Дата рождения должна быть в формате: число.месяц.год')
    .required('Обязательное поле')
    .test('valid-date', 'Введите корректную дату (не в будущем и не старше 100 лет)', validateDate),
  consent: yup.boolean().oneOf([true], 'Я даю согласие на обработку персональных данных обязателен'),
});
